let Countries = {
  BRAZIL: { id: 31, name: 'brazil' },
};

export default Countries;
export const countries = Object.keys(Countries).map(key => Countries[key]);



// WEBPACK FOOTER //
// ./src/enums/Countries.js